import { render, staticRenderFns } from "./ListOfAttendees.vue?vue&type=template&id=20d2fddc&scoped=true&"
import script from "./ListOfAttendees.vue?vue&type=script&lang=js&"
export * from "./ListOfAttendees.vue?vue&type=script&lang=js&"
import style0 from "./ListOfAttendees.vue?vue&type=style&index=0&id=20d2fddc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d2fddc",
  null
  
)

export default component.exports